// client-web-appsuite/src/constants/augmentation.js

let AUGMENTATION_STYLE = Object.freeze({
    PHOTOREALISTIC: 'photorealistic',
    LOW_POLY: 'low poly',
    RENDER: 'rendered',
    TOON: 'toon shading'
})

let AUGMENTATION_POSE = Object.freeze({
    APOSE: 'a-pose',
    TPOSE: 't-pose',
    NEUTRAL: 'neutral',
    SITTING: 'sitting',
    WALKING: 'walking'
})

let AUGMENTATION_VIEW = Object.freeze({
    FRONT: 'front',
    BACK: 'back',
    LEFT: 'left',
    RIGHT: 'right',
    DIAGONAL: 'diagonal',
})

let AUGMENTATION_DEFAULT = Object.freeze({ 
    styles: [ 'photorealistic' ], 
    poses: [], 
    views: [] 
})


let AUGMENTATION = Object.freeze({
    STYLE: AUGMENTATION_STYLE,
    POSE: AUGMENTATION_POSE,
    VIEW: AUGMENTATION_VIEW,
    DEFAULT: AUGMENTATION_DEFAULT
})


export default AUGMENTATION